import { tableStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListTable";
import { css } from "styled-components";

tableStyles.container = {
    css: css`
        overflow: auto;
        margin-top: 5px;
        margin-bottom: 20px;
    `,
};
